<router-outlet></router-outlet>

<app-alert-modal></app-alert-modal>